const typeDict = {
  0: 'Текст',
  1: 'Файлы',
  2: 'Скриншот',
};

export const type = (val) => typeDict[val];
